import {makeEnumTypeGuard} from '../../models/api/types/enumTypes';

export enum FeatureFlagsEnum {
  ADMIN_COMMAND_CENTER_P_0_ENTRY_POINT = 'admin-command-center-p-0-entry-point',
  AI_AUTO_REPLIES_ACTION = 'ai-auto-replies-action',
  AI_COMPOSE_V2_FLOATING_BUTTON = 'ai-compose-v2-floating-button',
  AI_DISABLE_COMPOSE_WHEN_TOO_SHORT = 'ai-disable-compose-when-too-short',
  AI_REMOVE_TOPIC_FROM_CONVERSATION = 'ai-remove-topic-from-conversation',
  AI_TAGGING_TAG_LIMIT = 'ai-tagging-tag-limit',
  AI_PROMPT_KEEP_AUTO_SUBMITTED = 'ai-prompt-keep-auto-submitted',
  AI_COMMAND_CENTER_SIMPLIFIED_ECHO_ANSWERS_REVIEW = 'ai-command-center-simplified-echo-answers-review',
  AI_COMMAND_CENTER_AI_DRAFT_SEND_BUTTON = 'ai-draft-send-button',
  AI_COMMAND_CENTER_SURFACE_AI_REPLIES_FEEDBACK = 'ai-command-center-surface-ai-replies-feedback',
  AI_COMMAND_CENTER_SURFACE_DISCARDED_DRAFTS = 'ai-command-center-surface-discarded-drafts',
  AI_COMMAND_CENTER_GENERATED_REPLY_FEEDBACK_MODAL_V2 = 'generated-reply-feedback-modal-v-2',
  AI_COMMAND_CENTER_REPLIES_HUB_EDIT_LEVELS = 'ai-command-center-replies-hub-edit-levels',
  AI_NOTES_KNOWLEDGE_SOURCE = 'ai-notes-knowledge-source',
  AI_RULE_REASONING_DEBUG_COMMENT = 'ai-rule-reasoning-debug-comment',
  AI_KNOWLEDGE_SEGMENTATION_MVP = 'ai-knowledge-segmentation-mvp',
  ANALYTICS_V4_CANDIDATE = 'analytics-v4',
  ANALYTICS_SHOW_DEPRECATED_REPORTS = 'analytics-show-deprecated-reports',
  ANALYTICS_WORKLOAD_TOUR = 'analytics-workload-tour',
  ANALYTICS_ES_TO_CH_DATA_MIGRATION = 'analytics_es_to_ch_data_migration',
  ANALYTICS_CLICKHOUSE_METRICS = 'analytics-clickhouse-metrics',
  ANALYTICS_ENABLE_TASK_INGESTION = 'analytics-enable-task-ingestion',
  ANALYTICS_CUSTOM_FIELDS_TABLE_METRICS = 'analytics-custom-fields-table-metrics',
  ANALYTICS_SEGMENT_INACTIVITY_TIMEOUT_NEVER = 'analytics-segment-inactivity-timeout-never',
  APPLICATION_CONNECTOR_DEVELOPERS = 'application-connectors-developers',
  APPLICATION_CONNECTOR_OUTPUT_PRETTY_JSON = 'application-connector-output-pretty-json',
  ENRICHED_APP_REQUEST_OUTPUTS = 'enriched-app-request-outputs',
  APPLICATION_OAUTH2_PASSWORD_GRANT_TYPE = 'application-oauth-2-password-grant-type',
  APPLICATION_KNOWLEDGE_SOURCE_EDUCATION_TIP_GURU_CONFLUENCE = 'application-knowledge-source-education-tip-guru-confluence',
  APP_STORE_REDESIGN = 'app-store-redesign',
  ASK_COPILOT = 'ask-copilot',
  ASK_COPILOT_ANNOUNCEMENT = 'ask-copilot-announcement',
  ASK_COPILOT_EXPERIMENT_SUMMARIZE_HAIKU_MODEL = 'ask-copilot-experiment-summarize-haiku-model',
  ASK_COPILOT_EXPERIMENT_SUMMARIZE_QWEN_MODEL = 'ask-copilot-experiment-summarize-qwen-model',
  ASK_COPILOT_EXPERIMENT_GROUNDING_MINI_MODEL = 'ask-copilot-experiment-grounding-mini-model',
  ASK_COPILOT_EXPERIMENT_PLAN_LITE = 'ask-copilot-experiment-plan-lite',
  ASK_COPILOT_EXPERIMENT_REPLY_HAIKU_MODEL = 'ask-copilot-experiment-reply-haiku-model',
  ASK_COPILOT_EXPERIMENT_REPLY_READINESS = 'ask-copilot-experiment-reply-readiness',
  ASK_COPILOT_EXPERIMENT_RESEARCH_FINDINGS_DEDUP = 'ask-copilot-experiment-research-findings-dedup',
  ASK_COPILOT_EXPERIMENT_SEMANTIC_KEYWORDS_SEARCH = 'ask-copilot-experiment-semantic-keywords-search',
  ASK_COPILOT_EXPERIMENT_TABLE_BLUEPRINT = 'ask-copilot-experiment-table-blueprint',
  ASK_COPILOT_EXPERIMENT_AGENTIC_DISTILL = 'ask-copilot-experiment-agentic-distill',
  ASK_COPILOT_EXPERIMENT_VERBOSE_LOGS = 'ask-copilot-experiment-verbose-logs',
  ASK_COPILOT_KNOWLEDGE_SETTINGS = 'ask-copilot-knowledge-settings',
  ASK_COPILOT_EXPERIMENT_STARTER_SUMMARIZE = 'ask-copilot-experiment-starter-summarize',
  ASK_COPILOT_EXPERIMENT_SUMMARIZE_FAST_PATH = 'ask-copilot-experiment-summarize-fast-path',
  ASK_COPILOT_EXPERIMENT_SUMMARIZE_PROSE = 'ask-copilot-experiment-summarize-prose',
  ASK_COPILOT_SEARCH_ENTRY = 'ask-copilot-search-entry',
  COPILOT_COMPOSE_ACTIONS = 'copilot-compose-actions',
  AUTOCOMPLETE_MORE_RESULTS = 'autocomplete-more-results',
  CELLS_OFFLINE_CACHE = 'cells-conversations-caching',
  CELLS_OFFLINE_CACHE_REPORTING = 'cells-offline-cache-reporting',
  CELLS_SEARCH_SCROLL_RESET_FIX = 'cells-search-scroll-reset-fix',
  CELLS_SEARCH_SCROLL_RESET_LOGGING = 'cells-search-scroll-reset-logging',
  CHAT_AI_DISPATCHER = 'chat-ai-dispatcher',
  CHAT_WIDGET_REFRESH = 'chat-widget-refresh',
  CHAT_SELF_SERVE_EXPERIENCE_FOR_FRONT_USERS = 'chat-self-serve-experience-for-front-users',
  COMPANION_ADMIN_EXPERIENCE = 'companion-admin-experience',
  CLOSED_CONVERSATIONS = 'closed-conversations-ga',
  COMPANY_ENFORCED_SIGNATURES = 'company-enforced-signatures',
  COMPOSER_SHARED_DRAFT_PARTICIPANT_REMOVAL_PROMPT = 'composer-shared-draft-participant-removal-prompt',
  CONDITIONS_TOKEN_EDITOR = 'conditions-tokens-editor',
  CONTACTS_OTHER_NAMES_DIALOG = 'contacts-other-names-dialog',
  CONVERSATION_SYNOPSIS = 'conversation-synopsis',
  CONVERSATION_UNDO_BANNER_REDESIGN = 'conversation-undo-banner-redesign',
  COPILOT_COMPOSE_NEW_LINE_SPACE_TO_OPEN = 'copilot-compose-new-line-space-to-open',
  CALENDAR_REMINDERS_LOGGING = 'calendar-reminders-logging',
  CREATE_CALENDAR_EVENT_VERSION_FROM_ORPHAN = 'create-calendar-event-version-from-orphan',
  CREATE_CALENDAR_EVENT_VERSION_FROM_ORPHAN_OFFICE_365 = 'create-calendar-event-version-from-orphan-office-365',
  CUSTOM_PLUGIN_RELAY = 'custom-plugin-relay',
  DATA_GROUP_INSTRUMENTATION = 'data-group-instrumentation',
  DATADOG_RUM = 'datadog-rum',
  DEEP_PERFORMANCE_INSTRUMENTATION = 'deep-performance-instrumentation',
  DRAFT_CHECKSUM = 'draft-checksum',
  DROPDOWN_REDESIGN = 'dropdown-redesign',
  EDIT_PUBLISHED_APPLICATIONS = 'edit-published-applications',
  ENFORCE_CHANNELS_TEAMMATE_RATIO = 'enforce-channels-teammate-ratio',
  FEATURE_HELP_REQUEST_CTA = 'feature-help-request-cta',
  FRODO_ADMIN_COPILOT = 'frodo-admin-copilot',
  FRODO_COPY_THREAD_ID = 'frodo-copy-thread-id',
  FIX_COLLAPSE_ALL_PAGINATION = 'fix-collapse-all-pagination',
  FRONT_MAIL = 'enable-front-mail',
  GLG_INDIVIDUAL_RULE_WARNING = 'glg-individual-rule-warning',
  GRANULAR_OFFLINE_INDICATION = 'granular-offline-indication',
  HAS_CUSTOM_VIEWS = 'has-custom-views',
  HAS_SUGGESTED_SNOOZE_ENABLED = 'has-suggested-snooze-enabled',
  HIDE_AI_TAGGING_RULE_TEMPLATE = 'hide-ai-tagging-rule-template',
  HIDE_ASSIGNED_CONVERSATIONS = 'hide-assigned-conversations',
  HIDE_AUDIT_TRAIL = 'hide-audit-trail',
  HIDE_PRIVATE_CATEGORIES_P4 = 'hide-private-categories-p4',
  HIDE_TEAM_TAG_COUNTERS = 'hide-team-tag-counters',
  AI_COMPOSE_ASSISTANT = 'ai-compose-assistant',
  AI_COMPOSE_ASSISTANT_DEV = 'ai-compose-assistant-dev',
  INBOX_REDESIGN_P3_SUBJECT_TWO_LINES = 'inbox-redesign-p3-subject-two-lines',
  INCORRECT_ARCHITECTURE_BANNER_ENABLED = 'incorrect-architecture-banner-enabled',
  INTERNAL_AI_ANSWERS_ANNOUNCEMENT = 'internal-ai-answers-announcement',
  INTERNAL_TASKS = 'internal-tasks-versioned',
  INTERNAL_TASKS_V2 = 'internal-tasks-v2',
  INTERNAL_TASKS_V2_DUE_DATES = 'internal-tasks-v2-due-dates',
  INTERNAL_TOOLBAR = 'internal-toolbar',
  JIRA_PREBUILT_CONNECTORS = 'jira-prebuilt-connectors',
  JUMP_TO_BEGINNING_BANNER = 'jump-to-beginning-banner',
  KNOWLEDGE_BASE_ARTICLE_REACTIONS = 'knowledge-base-article-reactions',
  KNOWLEDGE_BASE_CONTACT_FORM_ADDITIONAL_FIELDS = 'knowledge-base-contact-form-additional-fields',
  KNOWLEDGE_BASE_END_USER_AUTH = 'restricted-kb-end-user-auth',
  KNOWLEDGE_BASE_PORTAL_ANALYTICS = 'knowledge-base-portal-analytics',
  KNOWLEDGE_BASE_STALE_ARTICLES_V2 = 'knowledge-base-stale-articles-v2',
  LEGACY_PLAN_MIGRATION = 'legacy-plan-migration',
  LENSES_INCREASED_INBOX_LIMIT = 'lenses-increased-inbox-limit',
  LOG_DRAG_AND_DROP_OPERATIONS = 'log-drag-and-drop-operations',
  EXPRESSION_COPILOT = 'expression-copilot',
  MACRO_COPILOT = 'macro-copilot',
  BRANCHING_RULE_COPILOT = 'branching-rule-copilot',
  MACRO_DRAFT = 'macro-draft',
  MESSAGE_TRANSLATION = 'message-translation-banner',
  MOBILE_CALENDAR_WRITE_GA = 'mobile-calendar-write-ga',
  MOBILE_COMPOSER_DRAFT_FIX = 'mobile-composer-draft-fix',
  DRAFT_CONTENT_SYNC = 'draft-content-sync',
  MOBILE_IMPROVED_EMAIL_RENDERING = 'mobile-improved-html-rendering',
  MOBILE_PREFETCHER = 'mobile-prefetcher',
  MORE_P2_PREFETCH = 'more-p2-prefetch',
  NEW_P3_PREFETCH = 'new-p3-prefetch',
  NEW_PREFETCH_V3 = 'new-prefetch-v3',
  OFFICE_365_IMPORTER_DEPRECATION = 'office-365-importer-deprecation',
  OFFLINE_CONVERSATION_CACHE = 'offline-conversation-cache',
  OLD_DESKTOP_VERSION_BANNER = 'old-desktop-version-banner',
  ONBOARDING_CHAT_AUTOMATION = 'onboarding-chat-automation',
  ONBOARDING_FLOW_V5 = 'onboarding-flow-v5',
  P2_FILTERS_REDESIGN = 'p2-filters-redesign',
  P2_SERVER_BOUNDARY = 'p2-server-boundary',
  P4_POP_OUT_ANY_PLUGIN = 'p4-pop-out-any-plugin',
  P4_START_GUIDE_HIDDEN = 'p4-start-guide-hidden',
  PERFORMANCE_DEBUG_LOGGING = 'performance-debug-logging',
  PERFORMANCE_METRIC_LOGGING_DESKTOP = 'performance-metric-logging',
  PERFORMANCE_METRIC_LOGGING_MOBILE = 'performance-metric-logging-mobile',
  POLICY_VIOLATION_WARNING = 'policy-violation-warning',
  PRE_CHAT_FORM_ENABLED = 'pre-chat-form-enabled',
  PRELOADED_CONVERSATIONS = 'preloaded-conversations',
  PREVENT_PIN_TEAM_TAGS = 'team-lenses-prevent-pin-team-tags',
  LEGACY_SLACK_ACCESS = 'legacy-slack-channel-access',
  LEGACY_DIALPAD_ACCESS = 'legacy-dialpad-channel-access',
  MACRO_BUTTON_IN_COMPOSER_TOOLBAR = 'macro-button-in-composer-toolbar',
  PUSH_ROOM_RECEIVING_LOGGING = 'push-room-receiving-logging',
  QUICK_CONNECT_CHANNELS = 'quick-connect-channels',
  QUICK_INSERT_TABLE = 'quick-insert-table',
  REACT_18_STRICT_MODE = 'react-18-strict-mode',
  REPEAT_FORMATTING = 'repeat-formatting',
  REQUEST_TRACE_TAG = 'request-trace-tag',
  RTL_LANGUAGE_SUPPORT = 'rtl-language-support',
  RULE_EDITOR_HIGHLIGHT_ERRORS = 'rule-editor-highlight-errors',
  RULE_REMOVE_FROM_ASSIGNMENT_QUEUES_ACTION = 'rule-clear-assignment-queues-action',
  RULES_DRY_RUN = 'rules-dryrun',
  SF_ASANA_PREBUILT_CONNECTORS_ANNOUNCEMENT = 'sf-asana-prebuilt-connectors-announcement',
  SEARCH_ENGLISH_STEMMER = 'search-english-stemmer',
  SEARCH_EMPTY_BEHAVIOR = 'search-empty-behavior',
  SEARCH_LOCATION_RESET_EXPERIMENT = 'search-location-reset-experiment',
  SEARCH_NEGATED_FILTERS = 'search-negated-filters',
  SEARCH_NEGATED_QUICK_FILTERS = 'search-negated-quick-filters',
  SEARCH_ENABLE_MATCH_RECENCY_SEARCH_ORDER = 'search-enable-match-recency-search-order',
  SELECTOR_PERFORMANCE_LOGGING = 'selector-performance-logging',
  SENDGRID_DNS_SUBUSER = 'sendgrid-dns-subuser',
  SERVICE_WORKER = 'service-worker',
  SETTINGS_HOMEPAGE = 'settings-homepage-client',
  SETTINGS_PREVIEWERS = 'settings-previewers',
  SETUP_GUIDE_DISCOVER_AI = 'setup-guide-discover-ai',
  SHARED_ACTIONS = 'shared-actions',
  SHOW_MARKDOWN_EMAIL_COMPOSER = 'show-markdown-email-composer',
  SKIP_ARCHIVE_WHEN_CHANGING_OTHER_ASSIGNEES = 'skip-archive-when-changing-other-assignees',
  SMART_PRODUCTS_CUSTOM_SMART_QA = 'smart-products-custom-smart-qa',
  SORT_P2_BY_SLA_TIMER = 'sort-p2-sla',
  SPLIT_SINGLE_THREADED_CONVOS = 'split-single-threaded-convos',
  STANDALONE_PORTAL = 'standalone-portal',
  STRIPE_CHECKOUT_SESSION = 'stripe-checkout-session',
  SUPPORT_AT_SCALE_ANNOUNCEMENT = 'support-at-scale-announcement',
  SUPPORT_CHAT_FALLBACK = 'support-chat-fallback',
  SW_BOOT_CACHE_PATCHING = 'sw-boot-cache-patching',
  TABLE_PASTE_IGNORE_PASTEASTEXT_PREFERENCE = 'table-paste-ignore-pasteastext-preference',
  RINGCENTRAL = 'ringcentral',
  TICKET_STATUS_GROUPS = 'ticket-status-groups',
  TICKETING_CUSTOM_STATUSES = 'ticketing-custom-statuses',
  TICKETING_CUSTOM_STATUSES_WORKFLOWS = 'custom-ticket-statuses-in-workflows',
  TIME_OFF_API = 'time-off-api',
  TRIGGERED_SUGGESTIONS = 'triggered-suggestions',
  WORKSPACE_PERMISSIONS = 'workspace-permissions',
  P1_EDIT_WORKSPACE_REDESIGN = 'p1-edit-workspace-redesign',
  P1_REORDER_WORKSPACE_SECTIONS = 'p1-reorder-workspace-sections',
  MESSAGE_TEMPLATE_PREVIEWS = 'message-template-previews',
  MOBILE_INBOX_REDESIGN_TOGGLE = 'mobile-inbox-redesign-toggle',
  CONVERSATION_QUARANTINE = 'conversation-quarantine',
  SETTINGS_DARK_MODE = 'settings-dark-mode',
  USER_SURVEY = 'user-survey',
  USER_SURVEY_ANNIVERSARY = 'user-survey-anniversary',
  OUTBOUND_RULE_VALIDATION = 'outbound-rule-validation',
  MENTIONS_IN_EMAIL_COMPOSER = 'mentions-in-email-composer',
  AI_GENERATE_WITH_INSTRUCTIONS = 'ai-generate-with-instructions',
  P3_HEADER_REDESIGN_FEEDBACK = 'p3-header-redesign-feedback',
  FRONT_UNWRAPPED_ANNOUNCEMENT = 'front-unwrapped-announcement',
  INBOX_IMPROVEMENTS_AUTO_ENABLE = 'inbox-improvements-auto-enable',
  INBOX_IMPROVEMENTS_FORCE_ENABLE = 'inbox-improvements-force-enable',
  INBOX_IMPROVEMENTS_FORCE_ENABLE_BACKFILL = 'inbox-improvements-force-enable-backfill',
  P1_REDESIGN_ADD_BUTTON_ON_EDIT_MODE = 'p1-redesign-add-button-on-edit-mode',
  USER_SURVEY_KEEPING_IN_LOOP = 'user-survey-keeping-in-loop',
  PLAYBOOKS_ALPHA = 'playbooks-alpha',
  PLAYBOOK_ATTACHMENTS = 'playbook-attachments',
  PLAYBOOK_FREEFORM_KNOWLEDGE_SOURCES = 'playbook-freeform-knowledge-sources',
  KNOWLEDGE_SOURCES_PAGE = 'knowledge-sources-page',
  TELEPHONY_AUTH_TAKEOVER = 'telephony-auth-takeover',
  P1_CREATE_PRIVATE_VIEW_REDESIGN = 'p1-create-private-view',
  DV_EVAL_MATH = 'dv-eval-math',
  FLOW_EDITOR_FLOATING_HEADER = 'flow-editor-floating-header',
  CHANNEL_TYPE_SETTINGS = 'channel-type-settings',
  ZOOM_CONTACT_CENTER_SMS = 'zoom-contact-center-sms',
  MENTIONS_TAB_AND_INBOX_FILTER = 'mentions-tab-and-inbox-filter',
  PUSH_TASK_QUEUE_PRIORITY = 'push-task-queue-priority',
  POPOVER_COORDINATOR_V2 = 'popover-coordinator-v2',
  MCP_SERVER_ENABLED = 'mcp-server-enabled',
}

export const isFeatureFlagsEnum = makeEnumTypeGuard(FeatureFlagsEnum);

// Feature flags targeting 15k+ segments are incorrectly provided by the backend, so we'll wait for the
// client SDK to fetch them instead.
export const clientOnlyFeatureFlags = [FeatureFlagsEnum.ANALYTICS_WORKLOAD_TOUR];
